import { FC } from 'react';
import DrawerAtom, { DrawerAtomProps } from 'components/atoms/DrawerAtom';
import DefaultButton from 'components/atoms/Button/DefaultButton';
import PrimaryButton from 'components/atoms/Button/PrimaryButton';
import { AlertNotificationOptionsModel } from 'functionalities/deviceAlertNotifications/resources/useAlertNotification';
import AlertNotificationLoadingDrawer from 'components/molecules/AlertNotificationLoadingDrawer';
import AlertNotificationForm from 'components/molecules/AlertNotificationForm';
import './styles.scss';

export interface Props extends DrawerAtomProps {
  options: AlertNotificationOptionsModel;
}

export const AlertNotificationDrawer: FC<Props> = ({ open, onClose, title, options }) => {
  const {
    alertNotificationLiterals,
    form,
    userList,
    initialValues,
    onFinishForm,
    onFinishFailed,
    onSaveAlertNotification,
    isAlertNotificationDrawerLoading,
  } = options;

  return (
    <DrawerAtom
      className={'AlertNotificationDrawer__wrapper'}
      open={open}
      onClose={onClose}
      size={'large'}
      title={<span className={'AlertNotificationDrawer__title'}>{title}</span>}
    >
      {isAlertNotificationDrawerLoading && <AlertNotificationLoadingDrawer />}
      {!isAlertNotificationDrawerLoading && (
        <AlertNotificationForm
          form={form}
          initialValues={initialValues}
          onFinish={onFinishForm}
          onFinishFailed={onFinishFailed}
          userList={userList}
          literals={alertNotificationLiterals}
        />
      )}
      <footer>
        <DefaultButton onClick={onClose} title={alertNotificationLiterals.secondaryButtonText} />
        <PrimaryButton title={alertNotificationLiterals.mainButtonText} onClick={onSaveAlertNotification} />
      </footer>
    </DrawerAtom>
  );
}